import { UserScreenshareSource } from 'features/layout/features/order/types';
import { UserId } from 'features/users/types';

export const filterScreenshareStreamsByIds = (
  streams: UserScreenshareSource[],
  ids: UserId[]
): UserScreenshareSource[] => {
  const idSet = new Set(ids);

  return streams.filter((stream) => idSet.has(stream.userId));
};
